export class Dom {
  static accordionSelector = '[data-accordion]'
  static accordionItemSelector = '[data-accordion-for] > button'
  static activeDataAttribute = '[data-accordion-status="open"]'

  get accordions() {
    return document.querySelectorAll(Dom.accordionSelector)
  }

  accordionItems(accordion) {
    return accordion.querySelectorAll(Dom.accordionItemSelector)
  }

  activeElement(element) {
    return element.closest(Dom.accordionSelector).querySelector(Dom.activeDataAttribute)
  }
}
